import {
  CUSTOM_FIELD_TYPE_ADDRESS_SELECTOR,
  CUSTOM_FIELD_TYPE_AMOUNT_INPUT,
  CUSTOM_FIELD_TYPE_CHECKBOX,
  CUSTOM_FIELD_TYPE_COMBOBOX,
  CUSTOM_FIELD_TYPE_COUNTRY_SELECTOR,
  CUSTOM_FIELD_TYPE_DATE_PICKER,
  CUSTOM_FIELD_TYPE_ENTITY_SELECTOR,
  CUSTOM_FIELD_TYPE_FORMATION_TYPES_SELECTOR,
  CUSTOM_FIELD_TYPE_INPUT,
  CUSTOM_FIELD_TYPE_MONTH_PICKER,
  CUSTOM_FIELD_TYPE_PERSONA_SELECTOR,
  CUSTOM_FIELD_TYPE_PHONE_INPUT,
  CUSTOM_FIELD_TYPE_RADIO,
  CUSTOM_FIELD_TYPE_STATE_SELECTOR,
  CUSTOM_FIELD_TYPE_STRING,
  CUSTOM_FIELD_TYPE_YEAR_PICKER,
} from "constants/aiQuestionCardFields";

export type CustomFieldType =
  | typeof CUSTOM_FIELD_TYPE_ENTITY_SELECTOR
  | typeof CUSTOM_FIELD_TYPE_STATE_SELECTOR
  | typeof CUSTOM_FIELD_TYPE_COUNTRY_SELECTOR
  | typeof CUSTOM_FIELD_TYPE_FORMATION_TYPES_SELECTOR
  | typeof CUSTOM_FIELD_TYPE_ADDRESS_SELECTOR
  | typeof CUSTOM_FIELD_TYPE_PERSONA_SELECTOR
  | typeof CUSTOM_FIELD_TYPE_INPUT
  | typeof CUSTOM_FIELD_TYPE_MONTH_PICKER
  | typeof CUSTOM_FIELD_TYPE_YEAR_PICKER
  | typeof CUSTOM_FIELD_TYPE_DATE_PICKER
  | typeof CUSTOM_FIELD_TYPE_PHONE_INPUT
  | typeof CUSTOM_FIELD_TYPE_COMBOBOX
  | typeof CUSTOM_FIELD_TYPE_RADIO
  | typeof CUSTOM_FIELD_TYPE_CHECKBOX
  | typeof CUSTOM_FIELD_TYPE_AMOUNT_INPUT
  | typeof CUSTOM_FIELD_TYPE_STRING;

export type CustomFieldOption = {
  label: string;
  value: string;
};

export type CustomField = {
  type: CustomFieldType;
  label: string;
  placeholder?: string;
  tooltip?: string;
  value: string | string[];
  is_required: boolean;
  options?: CustomFieldOption[];
  is_multi_select?: boolean;
};

export type CustomFieldFormValues = Record<string, string | string[]>;

export const fieldNameForIndex = (index: number): string => `field_${index}`;
